export function secsToHoursAndMins(secs: number) {
  const hours = Math.floor(secs / 3600);
  const minutes = Math.floor((secs % 3600) / 60);
  return { hours, minutes };
}

export function decimalHoursToHoursAndMins(decimalHours: number) {
  const absHours = Math.abs(decimalHours);
  let hours = Math.floor(absHours);
  let minutes = Math.round((absHours - hours) * 60);
  if (minutes === 60) {
    minutes = 0;
    hours += 1;
  }
  const negative = decimalHours < 0;
  return { hours, minutes, negative };
}
